import React, { useState } from "react";
import "../Footer.css";
import footerimage from "../Images/footer.png";
import facebookIcon from "../Images/facebook.png";
import instagramIcon from "../Images/instagram.png";
import linkedinIcon from "../Images/linkedin.png";
import twitterIcon from "../Images/twitter.png";

const Footer = () => {
  const [hoveredButton, setHoveredButton] = useState(null);

  const socialLinks = [
    { name: "Facebook", iconSrc: facebookIcon, link: "https://www.facebook.com/profile.php?id=61570314156329" },
    { name: "Instagram", iconSrc: instagramIcon, link: "https://www.instagram.com/visuar.solutions/" },
    { name: "LinkedIn", iconSrc: linkedinIcon, link: "https://www.linkedin.com/company/visuar-solutions/" },
    { name: "Twitter", iconSrc: twitterIcon, link: "https://x.com/visuarsolutions/" },
  ];

  return (
    <footer className="footer" style={{ backgroundImage: `url(${footerimage})` }}>
      <div className="social-links">
  {socialLinks.map((button, index) => (
    <button
      key={index}
      className={`social-button social-button-${button.name.toLowerCase()}`}
      onMouseEnter={() => setHoveredButton(index)}
      onMouseLeave={() => setHoveredButton(null)}
      onClick={() => window.open(button.link, "_blank")}
    >
      {hoveredButton === index ? (
        <img src={button.iconSrc} alt={`${button.name} Icon`} className="social-icon" />
      ) : (
        <span className="social-name">{button.name}</span>
      )}
    </button>
  ))}
</div>


      <div className="footer-content">
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>Email: info@visuarsolutions.com</p>
          <p>Phone: +92 309 772 8004</p>
          <p>Address: Visuar Solutions, Nicat, Rawalpindi, Pakistan</p>
        </div>

        <div className="footer-section">
          <h4 className="locationHeading">Our Location</h4>
          <div className="map-container">
            <iframe
              title="Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3322.916684561401!2d73.09742757479316!3d33.60746614108643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfebd613f6bfff%3A0x146f44d48f528642!2sNational%20Incubation%20Center%20for%20Aerospace%20Technologies%20-%20NICAT!5e0!3m2!1sen!2s!4v1734809000066!5m2!1sen!2s"
              height="150"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © 2024 Visuar Solutions. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
